import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from '@material-ui/core/IconButton';

import Plus from "mdi-material-ui/Plus";
import Delete from "mdi-material-ui/Delete";

import TitleBar from "../../components/TitleBar";
import TitleBarTitle from "../../components/TitleBarTitle";
import TitleBarButton from "../../components/TitleBarButton";
import DataTable from "../../components/DataTable";
import InternalStore from "../../stores/InternalStore";
import {checkMot} from "../../dictionnaire/checkMot";


class APIKeyRow extends Component {
  onDelete = () => {
    if (window.confirm("Are you sure you want to delete this api key?")) {
      InternalStore.deleteAPIKey(this.props.obj.id, resp => {
        this.props.history.push(`/organizations/${this.props.match.params.organizationID}/api-keys`);
      });
    }
  }

  render() {
    return(
      <TableRow
        key={this.props.obj.id}
        hover
      >
        <TableCell>{this.props.obj.id}</TableCell>
        <TableCell>{this.props.obj.name}</TableCell>
        <TableCell align="right">
          <IconButton aria-label={checkMot("delete")}><Delete onClick={this.onDelete} /></IconButton>
        </TableCell>
      </TableRow>
    );
  }
}

APIKeyRow = withRouter(APIKeyRow);


class ListOrganizationAPIKeys extends Component {
  getPage = (limit, offset, callbackFunc) => {
    InternalStore.listAPIKeys({
      organizationID: this.props.match.params.organizationID,
      limit: limit,
      offset: offset,
    }, callbackFunc);
  }

  getRow = (obj) => {
    return(<APIKeyRow obj={obj} />);
  }

  render() {
    return(
      <Grid container spacing={4}>
        <TitleBar
          buttons={
            <TitleBarButton
              label={checkMot("Create")}
              icon={<Plus />}
              to={`/organizations/${this.props.match.params.organizationID}/api-keys/create`}
            />
          }
        >
          <TitleBarTitle title={checkMot("Organization API keys")} />
        </TitleBar>
        <Grid item xs={12}>
          <DataTable
            header={
              <TableRow>
                <TableCell>{checkMot("ID")}</TableCell>
                <TableCell>{checkMot("Name")}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    );
  }
}

export default ListOrganizationAPIKeys;
